import { getFontSize } from '../../constants/fontSizes';

export const infoCardStyles = () => {
  return {
    card: {
      backgroundColor: '#FCFCFC0D',
      borderRadius: '18px',
      padding: {xs: "15px", lg: "30px"},
      display: 'flex',
      flexDirection: 'column',
      gap: {xs: "5px", lg: "8px"},
      backdropFilter: 'blur(6px)',
      WebkitBackdropFilter: 'blur(6px)',
    },
    heading: {
      fontFamily: 'Lato',
      fontWeight: 600,
      fontSize: getFontSize(38),
      lineHeight: {xs: '15px', md: '18px', lg: '20px', xl: '22px'},
      letterSpacing: '0%',
      color: 'secondary.main',
      marginBottom: '15px',
    },
    subtitle: {
      fontFamily: 'Lato',
      fontWeight: 400,
      fontSize: getFontSize(17),
      lineHeight: {xs: '15px', md: '18px', lg: '20px', xl: '22px'},
      letterSpacing: '0%',
      color: 'secondary.main',
    },
  };
};

